import { Controller } from "@hotwired/stimulus"

// The `$ / %` toggle on the holdings table (PRD §2.3). Every togglable figure
// is rendered TWICE by the server — once as dollars, once as a percentage —
// and this controller only decides which of the pair is visible.
//
// Rendering both is deliberate: the percentages are ratios of cent integers,
// and recomputing them in the browser from formatted dollar strings is how a
// table ends up showing two different numbers for the same fact. It also means
// the dollars are correct with JavaScript off; only the toggle is lost.
//
// There is no stored mode: each action repaints the whole table from the mode
// it names, so there is exactly one code path and no state to fall out of step
// with the buttons.
//
// CSP-safe: no inline handlers, no eval. Wire the buttons with
// data-action="click->holdings-display#showDollars" / "#showPercent".
export default class extends Controller {
  static targets = ["dollar", "percent", "dollarButton", "percentButton"]

  // The server renders the dollar view, so connect() only has to restore the
  // buttons' state — but repainting is idempotent and keeps the two in step
  // if the markup ever ships in the other mode.
  connect() {
    this.render(false)
  }

  showDollars() {
    this.render(false)
  }

  showPercent() {
    this.render(true)
  }

  render(percent) {
    this.dollarTargets.forEach((element) => { element.hidden = percent })
    this.percentTargets.forEach((element) => { element.hidden = !percent })

    this.#setActive(this.dollarButtonTargets, !percent)
    this.#setActive(this.percentButtonTargets, percent)
  }

  // aria-pressed as well as the class: the pair is a toggle, and a sighted
  // user gets the state from the highlight while everyone else gets nothing
  // without this.
  #setActive(buttons, active) {
    buttons.forEach((button) => {
      button.classList.toggle("active", active)
      button.setAttribute("aria-pressed", String(active))
    })
  }
}
